import { useAuth0 } from '@auth0/auth0-react';
import LoadingButton from '@mui/lab/LoadingButton';
import { useDispatch } from 'react-redux';
import { Box, Grid, styled, Typography, Stack, Button } from '@mui/material';
// import IconButton from '@mui/material/IconButton';
// import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import React, { useEffect, useState } from 'react';
import sendNotification from '../../utils/sendNotification';
import { addNetworkInvitees } from '../../redux/SchoolSlice';

import ProfilePanel from '../BasicComponents/ProfilePanel';
const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '200px',
}));

export const NetworkTeacherInvite = props => {
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [listItem, setListItem] = useState([]);
    const [sendRequestDisabled, setSendRequestDisabled] = useState(true);
    const [count, setCount] = useState(0);
    const [checkAll, setCheckAll] = useState(true);
    console.log('props', props);
    useEffect(() => {
        let toListItem = [];
        if (props.crtList !== undefined) {
            toListItem = props.crtList.map(data => {
                return {
                    ...data,
                    status:
                        typeof data.networkInvitation !== 'undefined'
                            ? data.networkInvitation
                            : undefined,
                    listType: 'Saved',
                    profileImage: data.img,
                    network: { status: '' },
                    networkRequest:
                        typeof data.networkRequest !== 'undefined'
                            ? data.networkRequest
                            : undefined,
                    check: false,
                };
            });
        }

        setListItem([...toListItem]);
    }, [props.crtList]);

    console.log('listItem--->', listItem);

    const sendInvites = async () => {
        setLoading(true);

        try {
            //need to know what list.type is actually meant to be?
            //Since list type is not set it is using the list.pk1 which is the crt list ID and not the gs1-pk which is the actual user pk1
            //OK... so list.type is meant to be passed in from crtList so that you know they are type teachers. The logic is based off this being provided.
            //Need to either get the backend to pass over type or the front end needs to add it
            let requestList = [];
            listItem.map(list => {
                if (list.check === true) {
                    requestList.push({
                        id: list.type === 'teacher' ? list['gs1-pk'] : list.pk1,
                        uniqueId: list.uniqueId,
                        type: list.type,
                        schoolId: list.type === 'school' ? list['gs1-pk'] : '',
                    });
                }
            });
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            const requestData = {
                'token': token,
                'request': {
                    'networkName': props.network?.network['gs1-pk'],
                    'type': 'teacher',
                    'requestNetwork': false,
                    'requestList': requestList,
                    'invitedBySchool': props.pk1,
                },
            };
            await dispatch(addNetworkInvitees(requestData))
                .then(i => {
                    if (i.type === 'school/addNetworkInvitees/fulfilled') {
                        console.log('request send');
                        setCount(0);
                        setSendRequestDisabled(false);
                        sendNotification(
                            'success',
                            3000,
                            'Network request sent'
                        );
                    } else {
                        sendNotification(
                            'error',
                            6000,
                            'Failed to send request'
                        );
                    }
                    //updateState
                    console.log(i);
                })
                .catch(err => {
                    sendNotification('error', 6000, 'Failed to send request');
                    console.log('catch block entered');
                });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (count > 0) {
            setSendRequestDisabled(false);
        } else {
            setSendRequestDisabled(true);
        }
    }, [count]);

    const selectAll = checkAll => {
        let list = [...listItem];
        let i = 0;
        for (let item of list) {
            let index = list.indexOf(item);
            if (checkAll) {
                // if (
                //     typeof item.network === 'undefined' &&
                //     typeof item.networkRequest === 'undefined'
                // ) {
                i = i + 1;
                if (list[index].networkInvitation === 'null') {
                    list[index].check = true;
                    setCount(i);
                }
            } else {
                // if (
                //     typeof item.network === 'undefined' &&
                //     typeof item.networkRequest === 'undefined'
                // ) {
                list[index].check = false;
                // }
                setCount(0);
            }
        }
        setCheckAll(checkAll);
        setListItem(list);
    };
    const select = (index, value) => {
        console.log(index, value);
        let list = [...listItem];

        list[index].check = !value;
        setListItem(list);
        const counts = listItem.filter(list => {
            return list.check === true;
        }).length;
        const checkCount = listItem.filter(list => {
            return typeof list.network === 'undefined';
        }).length;
        if (counts === checkCount) {
            setCheckAll(true);
        }
        if (counts < checkCount) {
            setCheckAll(false);
        }
        setCount(counts);
        console.log(index, value);
    };

    return (
        <Grid container>
            <Typography variant="h5" sx={{ margin: '10px 4px' }}>
                Invite a relief teacher to join the network
            </Typography>
            <Grid item xs={12}>
                <Grid container alignItems="center" width="97%">
                    <Grid item xs={12}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-end"
                            gap={5}
                        >
                            {' '}
                            <Typography variant="subtitle2">
                                Selected ( {count} )
                            </Typography>
                            <Button
                                variant="text"
                                size="medium"
                                onClick={() => {
                                    selectAll(!checkAll);
                                }}
                            >
                                Select All
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                {listItem &&
                    props.crtList !== undefined &&
                    props.crtList.length > 0 && (
                        <>
                            <Stack spacing={1} sx={{ padding: '14px 10px' }}>
                                {listItem.map((item, index) => (
                                    <div key={index}>
                                        {/* Display the header if it's the first item in a category */}
                                        {index === 0 ||
                                        listItem[index - 1].listType !==
                                            item.listType ? (
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {item.listType + ' Teachers'}
                                            </Typography>
                                        ) : null}
                                        <ProfilePanel
                                            key={index}
                                            id={index}
                                            data={item}
                                            select={select}
                                        />
                                    </div>
                                ))}
                            </Stack>
                        </>
                    )}

                {props.network.networkItems?.length > 0 && (
                    <>
                        <hr style={{ width: '97%', marginLeft: '0px' }} />
                        {/* TO DO: The others section and exclusive teachers should be the same */}
                        {props.network.networkItems.some(
                            data =>
                                data.sk1.startsWith('teacher_') &&
                                typeof data.profileImage !== 'undefined'
                        ) && (
                            <>
                                <Typography
                                    variant="h5"
                                    sx={{ textAlign: 'left' }}
                                >
                                    Exclusive Teachers
                                </Typography>
                                <Stack
                                    spacing={1}
                                    sx={{ padding: '14px 10px' }}
                                >
                                    {props.network.networkItems.map(
                                        (data, index) => {
                                            if (
                                                data.sk1.startsWith(
                                                    'teacher_'
                                                ) &&
                                                typeof data.profileImage !==
                                                    'undefined' &&
                                                data.status !== 'rejected'
                                            ) {
                                                return (
                                                    <ProfilePanel
                                                        key={index}
                                                        id={index}
                                                        data={data}
                                                    />
                                                );
                                            }
                                            return null; // Add this to handle the non-matching items
                                        }
                                    )}
                                </Stack>
                            </>
                        )}
                    </>
                )}
            </Grid>
            <Grid item xs={12} textAlign="center">
                <BookingButton
                    size="small"
                    onClick={sendInvites}
                    loading={loading}
                    disabled={sendRequestDisabled}
                    variant="contained"
                >
                    Send
                </BookingButton>
            </Grid>
        </Grid>
    );
};

export default NetworkTeacherInvite;
